
<fieldset class="fieldset">
  <div class="field">
    <div class="control radio-list">
      <button 
        v-for="(label, value) in stepOptions.allSizes" 
        :key="value" 
        @click="chooseSize(value)" 
        class="select-card size flex items-start  lg:items-center justify-between mb-3 hover:shadow transition-all font-rubik"
        :class="updates.size == value ? 'size-active' : 'size-inactive'"
        style="width: 100% !important;"
      >
        <span :class="['size-label', updates.size == value ? 'text-[#1049FB]' : 'text-[#334155]']">{{ label }}</span>
        <span>
          <img class="h-[42px]" :src="getSizeIcon(value)" alt="Container size" />
        </span>
        <span class="container-sizes-text text-start lg:text-center" v-html="containerSizesText(value)"/>
      </button>

      <button
        @click="chooseSize('CUSTOM')" 
        class="select-card size flex items-start justify-start lg:items-center lg:justify-between mb-4 mt-12 gap-2 hover:shadow transition-all font-rubik"
        :class="updates.size == 'CUSTOM' ? 'size-active' : 'size-inactive'"
        style="width: 100% !important;"
      >
        <div>
          <span :class="['size-label', updates.size == 'CUSTOM' ? 'text-[#4D84FF]' : 'text-[#334155]']">Custom sizes available</span>
          <button class="custom-action-button transition-all flex justify-center items-center mt-1">
            <p>Talk to a Sales Rep</p>
          </button>
        </div>
        <img class="h-[42px]" :src="getSizeIcon('CUSTOM')" alt="Custom container size" />
      </button>
    </div>
  </div>
</fieldset>
